import { render, staticRenderFns } from "./MrIcon.vue?vue&type=template&id=6633bd4a&lang=pug&"
import script from "./MrIcon.vue?vue&type=script&lang=js&"
export * from "./MrIcon.vue?vue&type=script&lang=js&"
import style0 from "./MrIcon.vue?vue&type=style&index=0&id=6633bd4a&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports